<template>
    <div class="video-tour-container">
        <template v-if="!url">
            <button class="button button-m button-primary mb-40" @click.prevent="showEmbedVirtualTour()">{{ $t('components.embed_virtual_tour.embed_video') }}</button>
        </template>
        <template v-else>
            <div class="video-tour-inner-container">
                <div class="video-tour-container__iframe-wrap">
                    <iframe :src="url"></iframe>
                </div>
                <div class="video-tour-container__bottom">
                    <p class="text-secondary">{{ url }}</p>

                    <button class="button button-remove" @click.prevent="removeVirtualTour()"><img src="/img/bin.svg" alt="">{{ $t('common.remove') }}</button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            url: {
                default: null,
                type: String
            }
        },
        data() {
            return {
                
            }
        },
        computed: {
        },
        methods: {
            showEmbedVirtualTour() {
                this.$emit('show_embed_virtual_tour')
            },
            removeVirtualTour() {
                this.$emit('removed')
            }
        },
        watch: {
        }
    }
</script>
